import { engineComponent } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../Components/ComponentTypes";
import { WinAnimator } from "../GameComponents/WinAnimator";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { Symbols } from "../GameComponents/Symbols";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { BaseView } from "../GameComponents/Base/BaseView";
import { PlayList } from "../Components/Sounds/PlayList";
import { Payline } from "../GameComponents/Payline";
import { Symbol } from "../GameComponents/Symbol";
import { PaylinesExtended } from "./PaylinesExtended";
import { Settings } from "./Settings";
import { PaylinesDefinitions } from "../GameComponents/PaylinesDefinitions";
import { RopeElement } from "./RopeElement";
import { GameManager } from "../Managers/GameManager";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../Utils/FrameTimer";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimatorExtended extends WinAnimator {
    public groupTweens: SwitchElement;

    // ActiveElements
    private _activeElementsNames: Array<string> = [];
    private _activeElements: Array<SwitchElement> = [];
    private _activeElementsCase: string;
    private _paylinesOffsetsLeftX: Array<number> = [];
    private _paylinesOffsetsLeftY: Array<number> = [];
    private _paylinesOffsetsRightX: Array<number> = [];
    private _paylinesOffsetsRightY: Array<number> = [];

    protected _scatterCount: number = 0;
    protected _scatterDoubleCount: number = 0;
    protected paylinesLines: PaylinesExtended;
    protected _expandWildElement: Array<SwitchElement> = [];
    protected _newWildSymbol: Array<Symbol> = [];
    protected _reelLight: Array<SwitchElement> = [];
    protected _background: SwitchElement;
    protected _logo: SwitchElement;
    public _reelWild: Array<number> = [-1, -1, -1, -1, -1];

    private static readonly IdleStep: string = "idleStep";
    private currentIdleSteps: Array<Array<Array<number>>>;

    private currentImpactSymbols: Array<Array<Symbol>>;

    private _logoDelay: FrameTimerEventEmitter;
    private _expandDelay: FrameTimerEventEmitter;

    configure(node: Element): void {
        super.configure(node);

        if (node.hasAttribute(WinAnimatorExtendedAttributes.ACTIVE_ELEMENTS)) {
            this._activeElementsNames = node.getAttribute(WinAnimatorExtendedAttributes.ACTIVE_ELEMENTS).split(";");
        }
        if (node.hasAttribute(WinAnimatorExtendedAttributes.PAYLINES_OFFSETS_LEFT_X)) {
            this._paylinesOffsetsLeftX = node
                .getAttribute(WinAnimatorExtendedAttributes.PAYLINES_OFFSETS_LEFT_X)
                .split(";")
                .map((value) => parseInt(value));
        }
        if (node.hasAttribute(WinAnimatorExtendedAttributes.PAYLINES_OFFSETS_LEFT_Y)) {
            this._paylinesOffsetsLeftY = node
                .getAttribute(WinAnimatorExtendedAttributes.PAYLINES_OFFSETS_LEFT_Y)
                .split(";")
                .map((value) => parseInt(value));
        }
        if (node.hasAttribute(WinAnimatorExtendedAttributes.PAYLINES_OFFSETS_RIGHT_X)) {
            this._paylinesOffsetsRightX = node
                .getAttribute(WinAnimatorExtendedAttributes.PAYLINES_OFFSETS_RIGHT_X)
                .split(";")
                .map((value) => parseInt(value));
        }
        if (node.hasAttribute(WinAnimatorExtendedAttributes.PAYLINES_OFFSETS_RIGHT_Y)) {
            this._paylinesOffsetsRightY = node
                .getAttribute(WinAnimatorExtendedAttributes.PAYLINES_OFFSETS_RIGHT_Y)
                .split(";")
                .map((value) => parseInt(value));
        }
    }

    protected createSymbols(
        symbols: Symbols,
        noWinSymbolsContainer: ContainerElement,
        symbolsContainer: ContainerElement,
    ): void {
        this.symbols = symbols;
        if (noWinSymbolsContainer != null) {
            this.noWinSymbolsContainer = noWinSymbolsContainer;
        } else {
            this.noWinSymbolsContainer = new ContainerElement();
            this.noWinSymbolsContainer.name = "NoWinSymbols";

            this.addChild(this.noWinSymbolsContainer);
        }

        if (symbolsContainer != null) {
            this.symbolsContainer = symbolsContainer;
        } else {
            this.symbolsContainer = new ContainerElement();
            this.symbolsContainer.name = "Symbols";

            this.addChild(this.symbolsContainer);
        }

        this.currentSymbols = [];
        this.currentImpactSymbols = [];

        for (let i = 0; i < this.reelCount; i++) {
            this.currentSymbols.push([]);
            this.currentImpactSymbols.push([]);
            for (let j = 0; j < this.symbolCount; j++) {
                this.currentSymbols[i].push(null);
                this.currentImpactSymbols[i].push(null);
            }
        }
    }

    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    protected createPaylines(paylines: PaylinesExtended, paylinesLines?: PaylinesExtended): void {
        if (paylines) {
            this.paylines = paylines;
        }

        if (paylinesLines) {
            this.paylinesLines = paylinesLines;
        }

        // this.allPaylinesGoToCase(Payline.CaseNormal);
        this.allPaylinesGoToCase(Payline.CaseInit);
    }

    initialize(
        symbols: Symbols,
        paylines?: PaylinesExtended,
        paylinesLines?: PaylinesExtended,
        noWinSymbolsContainer?: ContainerElement,
        symbolsContainer?: ContainerElement,
        parent?: BaseView,
    ): void {
        super.initialize(symbols, paylines, noWinSymbolsContainer, symbolsContainer);

        if (paylinesLines) {
            this.createPaylines(null, paylinesLines);
        }

        if (parent) {
            this._activeElementsNames.forEach((elementName) => {
                if (parent.childs[elementName] && parent.childs[elementName] instanceof SwitchElement) {
                    this._activeElements.push(parent.childs[elementName]);
                }
            });

            if (parent.childs["ExpandWildContainer"]) {
                for (let i = 1; i < this.reelCount - 1; i++) {
                    if (parent.childs["ExpandWildContainer"].childs["Reel" + i]) {
                        this._expandWildElement[i] = parent.childs["ExpandWildContainer"].childs["Reel" + i];
                    }
                }
            }

            if (parent.childs["ReelsBg"]) {
                for (let i = 1; i < this.reelCount - 1; i++) {
                    if (parent.childs["ReelsBg"].childs["Light" + i]) {
                        this._reelLight[i] = parent.childs["ReelsBg"].childs["Light" + i];
                    }
                }
            }

            if (parent.childs["Background"]) {
                this._background = parent.childs["Background"];
            }
            if (parent.childs["Logo"]) {
                this._logo = parent.childs["Logo"];
            }
            if (parent.childs["GroupTweens"]) {
                this.groupTweens = parent.childs["GroupTweens"];
            }
        }
        this._logoDelay = CreateFrameTimer("logoDelay");
        this._logoDelay.on(FrameTimerEvents.Complete, this.idleLogo.bind(this));

        this._expandDelay = CreateFrameTimer("expandDelay");
        this._expandDelay.on(FrameTimerEvents.Complete, this.expandDelayed.bind(this));
    }

    protected allPaylinesGoToCase(caseType: string): void {
        if (this.paylines != null) {
            this.paylines.goToCase(caseType);
        }

        if (this.paylinesLines != null) {
            this.paylinesLines.goToCase(caseType);
        }
    }

    public getReelCount(): number {
        return this.reelCount;
    }

    protected winPaylineGoToCase(winIndex: number, caseType: string): void {
        if (this.paylines != null) {
            const win = this.currentWins[winIndex];

            if (win.trigger === Communication.Game.WinTrigger.Payline) {
                if (caseType === Payline.CaseCycle && this.currentWins.length === 1) {
                    this.paylines.goToCase(Payline.CaseSingleCycle, win.paylineId);

                    if (this.paylinesLines != null) {
                        this.paylinesLines.goToCase(Payline.CaseSingleCycle, win.paylineId);
                    }
                } else {
                    this.paylines.goToCase(caseType, win.paylineId);

                    if (this.paylinesLines != null) {
                        this.paylinesLines.goToCase(caseType, win.paylineId);

                        // if Payline named "PaylineLine_1" ....
                        // this.updateRopeElementPointsInPayline(win, win.paylineId);
                    }
                }
            }
        }
    }

    protected addCurrentSymbol(reelIndex: number, symbolIndex: number): void {
        if (this.currentSymbols[reelIndex][symbolIndex] === null) {
            const id = this.currentReels[reelIndex].symbols[symbolIndex];
            let symbol: Symbol = null;

            if (this.currentImpactSymbols[reelIndex] && this.currentImpactSymbols[reelIndex][symbolIndex] !== null) {
                symbol = this.currentImpactSymbols[reelIndex][symbolIndex];
                this.currentImpactSymbols[reelIndex][symbolIndex] = null;
            } else {
                symbol = this.symbols.getSymbol(id - 1, Symbol.CaseNormal);
                symbol.position.x = this.reelX[reelIndex] - symbol.offsetX;
                symbol.position.y = this.reelY[reelIndex] + this.symbolHeight * symbolIndex - symbol.offsetY;
            }

            this.symbolsContainer.addChild(symbol);

            this.currentSymbols[reelIndex][symbolIndex] = symbol;
        }
    }

    public onSpinPostRoll(impactSymbols: Array<Symbol>, reelIndex: number): void {
        if (this.currentImpactSymbols) {
            if (
                GameManager.baseResponse.screen.reels[reelIndex].transform &&
                GameManager.baseResponse.screen.reels[reelIndex].transform.indexOf(Settings.SymbolWild) !== -1
            ) {
                let wildIndex = GameManager.baseResponse.screen.reels[reelIndex].symbols.indexOf(Settings.SymbolWild);
                if (wildIndex !== -1) {
                    this._reelWild[reelIndex] = wildIndex;
                }
            }
            impactSymbols.forEach((value, index) => {
                if (value !== null && this.currentImpactSymbols[reelIndex]) {
                    let symbol = (this.currentImpactSymbols[reelIndex][index] = value);
                    this.symbolsContainer.addChild(symbol);
                    let symbolId = symbol.id + 1;
                    switch (symbolId) {
                        case Settings.SymbolScatter:
                            if (this._scatterCount + this.reelCount - reelIndex >= 3) {
                                this._scatterCount++;
                                PlayList.play("SND_BaseScatterHit" + reelIndex);
                                symbol.goToCase(Symbol.CaseImpact);
                            }
                            break;
                        case Settings.SymbolScatterDouble:
                            if (
                                reelIndex === 0 ||
                                (reelIndex === 2 && this._scatterDoubleCount >= 1) ||
                                (reelIndex === 4 && this._scatterDoubleCount >= 2)
                            ) {
                                this._scatterDoubleCount++;
                                PlayList.play("SND_BaseScatterDoubleHit" + reelIndex);
                                symbol.goToCase(Symbol.CaseImpact);
                            }
                            break;
                        case Settings.SymbolWild:
                            PlayList.play("SND_BaseWildHit" + reelIndex);
                            symbol.goToCase(Symbol.CaseImpact);
                            break;
                    }
                }
            });
        }
    }

    public onReelStopped(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        this.currentReels = reelsData;

        for (let i = 0; i < reelsData[reelIndex].symbols.length; i++) {
            this.removeCurrentSymbol(reelIndex, i);
        }

        // for (let i = 0; i < reelsData[reelIndex].symbols.length; i++) {
        for (let i = reelsData[reelIndex].symbols.length - 1; i >= 0; i--) {
            this.addCurrentSymbol(reelIndex, i);
        }
    }

    //******************************************************************************************************************
    //  SHOW WINS
    //******************************************************************************************************************

    public expandWild(): void {
        this._newWildSymbol = [];
        // wild can only appear on reel index 1, 2, 3
        for (let i = 1; i < this.reelCount - 1; i++) {
            if (this._reelWild[i] > -1) {
                for (let j = 0; j < this.currentSymbols[i].length; j++) {
                    if (this.currentSymbols[i][j].id + 1 === Settings.SymbolWild && this._expandWildElement[i]) {
                        this._expandWildElement[i].goToCase("EXPAND_" + j);
                        this.currentSymbols[i][j].goToCase(Symbol.CaseLoop);
                        this._reelLight[i].goToCase("SHOW");
                        break;
                    }
                }
                this._newWildSymbol[i] = this.symbols.getSymbol(Settings.SymbolWild - 1, Symbol.CaseLoop);
            }
        }
        this._expandDelay.stop();
        this._expandDelay.start(50);
    }

    protected expandDelayed(): void {
        this._expandDelay.stop();
        // change previous symbol on reel to symbol wild because of sorting (to not cut wild text)
        for (let i = 1; i < this.reelCount - 1; i++) {
            if (this._reelWild[i] > -1) {
                let nextIndex: number = -1;
                switch (this._reelWild[i]) {
                    case 0:
                        nextIndex = 1;
                        break;
                    case 1:
                        nextIndex = 0;
                        break;
                    case 2:
                        nextIndex = 1;
                        break;
                }
                this._newWildSymbol[i].position.x = this.currentSymbols[i][nextIndex].x;
                this._newWildSymbol[i].position.y = this.currentSymbols[i][nextIndex].y;
                this.symbols.returnSymbol(this.currentSymbols[i][nextIndex]);
                this.currentSymbols[i][nextIndex] = this._newWildSymbol[i];
                this.symbolsContainer.addChild(this._newWildSymbol[i]);
                // sort symbols from bottom to top
                if (this._reelWild[i] < nextIndex) {
                    const reelSymbol = this.currentSymbols[i][this._reelWild[i]];
                    this.symbolsContainer.addChild(reelSymbol);
                }
                this._expandWildElement[i].goToCase("EXPAND_" + this._reelWild[i] + "_1");
            }
        }
    }

    protected showFirstWins(): void {
        this._background.goToCase("WIN");
        this._logo.goToCase("START");

        for (let i = 1; i < this.reelCount - 1; i++) {
            if (this._reelWild[i] > -1) {
                for (let j = 0; j < this.currentSymbols[i].length; j++) {
                    // no need to add wild that was already on reel & sorting is solved later
                    if (j !== this._reelWild[i]) {
                        this._newWildSymbol[i] = this.symbols.getSymbol(Settings.SymbolWild - 1, Symbol.CaseLoop);
                        this._newWildSymbol[i].position.x = this.currentSymbols[i][j].x;
                        this._newWildSymbol[i].position.y = this.currentSymbols[i][j].y;
                        this.symbols.returnSymbol(this.currentSymbols[i][j]);
                        this.currentSymbols[i][j] = this._newWildSymbol[i];
                    }
                }
                if (this._expandWildElement[i]) {
                    this._expandWildElement[i].goToCase("EMPTY");
                }
                if (this._reelLight[i]) {
                    this._reelLight[i].goToCase("EMPTY");
                }
                this._reelWild[i] = -1;
            }
        }

        this.allSymbolsGoToCase(Symbol.CaseNowin, true);
        this.allPaylinesGoToCase(Payline.CaseNowin);

        for (let i = 0; i < this.currentWins.length; i++) {
            this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
            this.winPaylineGoToCase(i, Payline.CaseWin);
        }

        this.sortSymbols(this.noWinSymbolsContainer, this.symbols);
        this.sortSymbols(this.symbolsContainer, this.symbols);
        this.startAnimation();
    }

    protected showFirstInitWins(): void {
        this._background.goToCase("WIN");
        for (let i = 0; i < this.reelCount; i++) {
            if (
                GameManager.baseResponse.screen.reels[i].transform &&
                GameManager.baseResponse.screen.reels[i].transform.indexOf(Settings.SymbolWild) !== -1
            ) {
                for (let j = 0; j < this.currentSymbols[i].length; j++) {
                    const symbol = this.symbols.getSymbol(Settings.SymbolWild - 1, Symbol.CaseNormal);
                    symbol.position.x = this.currentSymbols[i][j].x;
                    symbol.position.y = this.currentSymbols[i][j].y;
                    this.symbols.returnSymbol(this.currentSymbols[i][j]);
                    this.currentSymbols[i][j] = symbol;
                }
            }
        }

        super.showFirstInitWins();
    }

    public sortSymbols(container: ContainerElement, symbols: Symbols): void {
        if (!container || !symbols || (!symbols.hasZindex && !symbols.heightOrdering)) {
            return;
        }

        let addQueue: Symbol[] = [];

        container.children.forEach((symbol) => {
            if (symbol) {
                addQueue.push(<Symbol>symbol);
            }
        });
        addQueue.sort((a, b) => {
            let rev = a.zReverse || b.zReverse ? -1 : 1;
            return symbols.hasZindex && symbols.heightOrdering
                ? a.zIndex == b.zIndex
                    ? b.position.y == a.position.y
                        ? -rev * (b.position.x - a.position.x)
                        : b.position.y - a.position.y
                    : a.zIndex - b.zIndex
                : symbols.hasZindex
                  ? a.zIndex - b.zIndex
                  : b.position.y - a.position.y;
        });
        addQueue.forEach((symbol) => {
            container.addChild(symbol);
        });
    }

    //******************************************************************************************************************
    //  RESET
    //******************************************************************************************************************

    public reset(showLastSymbols: boolean, spin = false): boolean {
        this.stopTimer();
        this._logoDelay.stop();

        PlayList.stop("SND_BaseWinline");

        this.allSymbolsGoToCase(showLastSymbols ? Symbol.CaseNormal : Symbol.CaseEmpty, false);

        this.allPaylinesGoToCase(Payline.CaseNormal);

        if (showLastSymbols && !spin) {
            this.startTimer(WinAnimator.Idle, this.getInitialIdleDelay());
        }
        if (showLastSymbols) {
            this._scatterCount = 0;
            this._scatterDoubleCount = 0;
            if (this._background.getCurrentCase() === "WIN") {
                this._background.goToCase("OUTRO");
            }
        }

        this.value.visible = false;

        let lastMultiplierIndex = this.currentMultiplierIndex;
        this.currentMultiplierIndex = -1;

        if (this.currentAnimationIndex != null) {
            if (this.currentAnimationFinished) {
                this.resetAnimations();

                this.currentWins = null;
                this.currentWin = null;
                return false;
            } else {
                this.stopAnimation();

                this.currentWins = null;
                this.currentWin = null;
                return lastMultiplierIndex >= 2; // condition should be greater than or equals 2 beacause we`ve got only two types of base wins (before high wins)
            }
        } else {
            this.currentWins = null;
            this.currentWin = null;
            //return (lastMultiplierIndex >= 2); // condition should be greater than or equals 2 beacause we`ve got only two types of base wins (before high wins)
            return false;
        }
    }

    //******************************************************************************************************************
    //  ACTIVE ELEMENTS
    //******************************************************************************************************************

    /**
     * Attempts to switch all Active Elements to the earliest case from array the element can be switched to.
     * Elements with no case from the list are ignored.
     * @param s Array of names of cases to try to switch to
     * @param emitEvent
     * @param delay Switch delay
     */
    private setActiveElementCaseArray(s: Array<string>, emitEvent: boolean = false, delay?: number) {
        if (!s.length) {
            return;
        }
        if (!this.visible) {
            return;
        }
        this._activeElementsCase = s[0];
        this._activeElements.forEach((element) => {
            for (let i = 0; i < s.length; i++) {
                if (element.hasCase(s[i])) {
                    element.goToCase(s[i], emitEvent, delay);
                    break;
                }
            }
        });
    }

    /**
     * Attempts to switch all Active Elements to the given case if they have this case.
     * Elements without the case are ignored.
     * @param s Case name
     * @param emitEvent
     * @param delay
     */
    private setActiveElementCase(s: string, emitEvent: boolean = false, delay?: number) {
        if (!this.visible) {
            return;
        }
        this._activeElementsCase = s;
        this._activeElements.forEach((element) => {
            if (element.hasCase(s)) {
                element.goToCase(s, emitEvent, delay);
            }
        });
    }

    /**
     * Returns last case switched to, or the first case from a list switched to.
     */
    private getActiveElementCase(): string {
        return this._activeElementsCase;
    }

    //******************************************************************************************************************
    //  CYCLE WINS
    //******************************************************************************************************************

    protected cycleWins(isFirst: boolean = false): void {
        if (this.currentWins == null) {
            return;
        }

        if (isFirst) {
            this.cycleStep = 0;
        } else {
            this.cycleStep++;
        }

        PlayList.play("SND_BaseWinline");

        if (this.cycleStep % 4 === 0) {
            this.cycleStep = 0;
            PlayList.loop("SND_BaseRecapLoop", 0, true);
            this._logo.goToCase("START");
        }

        this.allPaylinesGoToCase(Payline.CaseNowin);

        for (let i = 0; i < this.currentWins.length; i++) {
            this.winPaylineGoToCase(i, Payline.CaseNormal);
            this.winSymbolsGoToCase(i, Symbol.CaseNormal, false);
        }

        this.sortSymbols(this.symbolsContainer, this.symbols);

        if (this.currentCycle < this.currentWins.length) {
            this.winSymbolsGoToCase(this.currentCycle, Symbol.CaseCycle, true);
            this.winPaylineGoToCase(this.currentCycle, Payline.CaseCycle);
        }

        if (this.currentWins.length === 1) {
            return;
        }

        this.currentCycle = (this.currentCycle + 1) % this.currentWins.length;

        this.startTimer(WinAnimator.CycleWins, this.getCycleWinsDelayWithCorrection(isFirst));
    }

    protected winSymbolsGoToCaseAsPayline(winIndex: number, caseType: string): Array<Symbol> {
        const win = this.currentWins[winIndex];
        const symbols: Array<Symbol> = [];

        if (this.paylines != null) {
            const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                win.paylineId,
                this.paylines.paylineDefinition,
            );

            for (let i = 0; i < definition.length; i++) {
                if (win.mask[i] === 1 && this.allowSymbolGoToCase(i, definition[i], caseType)) {
                    const symbol = this.currentSymbols[i][definition[i]];
                    if (symbol.id + 1 === Settings.SymbolWild && caseType === Symbol.CaseNormal) {
                        symbol.goToCase(Symbol.CaseLoop);
                    } else {
                        symbol.goToCase(caseType);
                    }

                    this.symbolsContainer.addChild(symbol);

                    symbols.push(symbol);
                }
            }
        }

        return symbols;
    }

    private updateRopeElementPointsInPayline(wins: Object, paylineID: number): void {
        if (this.paylinesLines != null) {
            // payline element by ID (SwitchElement)
            let p: Payline = this.paylinesLines.childs["PaylineLine_" + paylineID];

            if (p && p instanceof Payline) {
                // array childs of Payline
                let o: Object = p.getChildElements() as Object;

                if (o && o instanceof Object) {
                    /*
                    // Color for TINT by win symbol
                    let winSymbol = 0;
                    let colorTint = 0xffffff;

                    if(wins) {
                        let symbols = wins['symbols'];
                        let mask = wins['mask'];

                        if (symbols && mask) {
                            for (let i = 0; i < symbols.length; i++) {
                                if(mask[i] === 1) {
                                    if(symbols[i] != 7 && symbols[i] != 8) {
                                        winSymbol = symbols[i];
                                    }
                                }
                            }
                        }
                    }

                    // color of symbol
                    switch(winSymbol) {
                        case 0:
                            colorTint = 0xffffff;
                            break;
                        case 1:
                            colorTint = 0xbef04b;
                            break;
                        case 2:
                            colorTint = 0x43e4f5;
                            break;
                        case 3:
                            colorTint = 0xf48225;
                            break;
                        case 4:
                            colorTint = 0xd176f7;
                            break;
                        case 5:
                            colorTint = 0xff054b;
                            break;
                        case 6:
                            colorTint = 0xfffe38;
                            break;
                        default:
                            colorTint = 0xffffff;
                            break;
                    }
                    */

                    // RopeElement
                    let ropeArray: Array<RopeElement> = [];

                    if (o["RopeElementLine"]) {
                        ropeArray.push(o["RopeElementLine"]);
                    }

                    if (o["RopeElementLineShine"]) {
                        ropeArray.push(o["RopeElementLineShine"]);
                    }

                    if (ropeArray && ropeArray.length > 0) {
                        let points: Array<PIXI.Point> = [];
                        const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                            paylineID,
                            this.paylines.paylineDefinition,
                        );

                        for (let i = 0; i < definition.length; i++) {
                            let w = this.symbolWidth;
                            let h = this.symbolHeight;
                            let x = this.reelX[i];
                            let y = this.reelY[i] + h * definition[i];

                            // ---------------------------------------------
                            // WARNING: symbol has pivot on left top corner
                            // ---------------------------------------------

                            // ADD FIRST POINT ON PAYLINE
                            if (i == 0) {
                                /* first point of payline, position on symbol "X"
                                           width
                                        /  0 0 0  \
                                height  |  X 0 0   | SYMBOL POSITION POINTS
                                        \  0 0 0  /
                                */
                                let newX: number = x;
                                let newY: number = y;
                                let offsetID: number = paylineID - 1;
                                if (
                                    this._paylinesOffsetsLeftX &&
                                    this._paylinesOffsetsLeftX.length > 0 &&
                                    this._paylinesOffsetsLeftX[offsetID]
                                ) {
                                    newX += this._paylinesOffsetsLeftX[offsetID];
                                }
                                if (
                                    this._paylinesOffsetsLeftY &&
                                    this._paylinesOffsetsLeftY.length > 0 &&
                                    this._paylinesOffsetsLeftY[offsetID]
                                ) {
                                    newY += this._paylinesOffsetsLeftY[offsetID];
                                }
                                // points.push(new PIXI.Point(x, (y + h / 2)));
                                points.push(new PIXI.Point(newX, newY + h / 2));
                            }

                            // ADD other points
                            /* other point of payline, position on symbol "X"
                                       width
                                    /  0 0 0  \
                            height  |  0 X 0   | SYMBOL POSITION POINTS
                                    \  0 0 0  /
                            */
                            points.push(new PIXI.Point(x + w / 2, y + h / 2));

                            // ADD LAST POINT ON PAYLINE
                            if (i == definition.length - 1) {
                                /* last point of payline, position on symbol "X"
                                           width
                                        /  0 0 0  \
                                height  |  0 0 X   | SYMBOL POSITION POINTS
                                        \  0 0 0  /
                                */
                                let newX: number = x;
                                let newY: number = y;
                                let offsetID: number = paylineID - 1;
                                if (
                                    this._paylinesOffsetsRightX &&
                                    this._paylinesOffsetsRightX.length > 0 &&
                                    this._paylinesOffsetsRightX[offsetID]
                                ) {
                                    newX += this._paylinesOffsetsRightX[offsetID];
                                }
                                if (
                                    this._paylinesOffsetsRightY &&
                                    this._paylinesOffsetsRightY.length > 0 &&
                                    this._paylinesOffsetsRightY[offsetID]
                                ) {
                                    newY += this._paylinesOffsetsRightY[offsetID];
                                }
                                points.push(new PIXI.Point(newX + w, newY + h / 2));
                                // points.push(new PIXI.Point((x + w + w / 2), (y + h / 2)));
                                // points.push(new PIXI.Point((x + w), (y + h / 2))); // + offset X
                            }
                        }

                        for (let r = 0; r < ropeArray.length; r++) {
                            if (ropeArray[r] && ropeArray[r] instanceof RopeElement) {
                                // if(r === 0) {
                                //     ropeArray[r].setTint(colorTint);
                                // }

                                ropeArray[r].updateByArrayPIXIPoint(points);
                            }
                        }
                    }
                }
            }
        }
    }

    protected onTimerComplete(): void {
        this.timer.stop();

        switch (this.timerStatus) {
            case WinAnimator.Idle:
                this.idle();
                break;
            case WinAnimator.CycleWins:
                this.cycleWins();
                break;
            case WinAnimatorExtended.IdleStep:
                this.idleStep();
                break;
        }
    }

    //******************************************************************************************************************
    //  IDLE
    //******************************************************************************************************************

    protected idleLogo(isFirst: boolean = false): void {
        this._logoDelay.stop();
        if (!isFirst) {
            this._logo.goToCase("START");
        }
        this._logoDelay.start(100 * (Math.floor(Math.random() * 3) + 2));
    }

    protected getInitialIdleDelay(): number {
        this.idleLogo(true);
        return 120;
    }

    protected idle(): void {
        this.currentIdleSteps = this.getIdleSteps();

        this.idleStep();
    }

    protected getIdleDelay(): number {
        return 60 * (Math.floor(Math.random() * 3) + 2);
    }

    private idleStep(): void {
        const positions = this.currentIdleSteps.shift();

        for (let i = 0; i < positions.length; i++) {
            if (this.currentSymbols[positions[i][0]][positions[i][1]] != null) {
                this.currentSymbols[positions[i][0]][positions[i][1]].goToCase(Symbol.CaseIdle);
            }
        }

        if (this.currentIdleSteps.length === 0) {
            this.startTimer(WinAnimator.Idle, 90 + this.getIdleDelay());
        } else {
            this.startTimer(WinAnimatorExtended.IdleStep, 15);
        }
    }

    private getIdleSteps(): Array<Array<Array<number>>> {
        switch (Math.round(Math.random() * 9)) {
            default:
            case 0: // LEFT TOP
                return [
                    [[0, 0]],
                    [
                        [0, 1],
                        [1, 0],
                    ],
                    [
                        [0, 2],
                        [1, 1],
                        [2, 0],
                    ],
                    [
                        [0, 3],
                        [1, 2],
                        [2, 1],
                        [3, 0],
                    ],
                    [
                        [1, 3],
                        [2, 2],
                        [3, 1],
                        [4, 0],
                    ],
                    [
                        [2, 3],
                        [3, 2],
                        [4, 1],
                    ],
                    [
                        [3, 3],
                        [4, 2],
                    ],
                    [[4, 3]],
                ];
            case 1: // RIGHT TOP
                return [
                    [[4, 0]],
                    [
                        [4, 1],
                        [3, 0],
                    ],
                    [
                        [4, 2],
                        [3, 1],
                        [2, 0],
                    ],
                    [
                        [4, 3],
                        [3, 2],
                        [2, 1],
                        [1, 0],
                    ],
                    [
                        [3, 3],
                        [2, 2],
                        [1, 1],
                        [0, 0],
                    ],
                    [
                        [2, 3],
                        [1, 2],
                        [0, 1],
                    ],
                    [
                        [1, 3],
                        [0, 2],
                    ],
                    [[0, 3]],
                ];
            case 2: // LEFT BOTTOM
                return [
                    [[0, 3]],
                    [
                        [0, 2],
                        [1, 3],
                    ],
                    [
                        [0, 1],
                        [1, 2],
                        [2, 3],
                    ],
                    [
                        [0, 0],
                        [1, 1],
                        [2, 2],
                        [3, 3],
                    ],
                    [
                        [1, 0],
                        [2, 1],
                        [3, 2],
                        [4, 3],
                    ],
                    [
                        [2, 0],
                        [3, 1],
                        [4, 2],
                    ],
                    [
                        [3, 0],
                        [4, 1],
                    ],
                    [[4, 0]],
                ];
            case 3: // RIGHT BOTTOM
                return [
                    [[4, 3]],
                    [
                        [4, 2],
                        [3, 3],
                    ],
                    [
                        [4, 1],
                        [3, 2],
                        [2, 3],
                    ],
                    [
                        [4, 0],
                        [3, 1],
                        [2, 2],
                        [1, 3],
                    ],
                    [
                        [3, 0],
                        [2, 1],
                        [1, 2],
                        [0, 3],
                    ],
                    [
                        [2, 0],
                        [1, 1],
                        [0, 2],
                    ],
                    [
                        [1, 0],
                        [0, 1],
                    ],
                    [[0, 0]],
                ];
            case 4: // LEFT TO RIGHT
                return [
                    [
                        [0, 0],
                        [0, 1],
                        [0, 2],
                        [0, 3],
                    ],
                    [
                        [1, 0],
                        [1, 1],
                        [1, 2],
                        [1, 3],
                    ],
                    [
                        [2, 0],
                        [2, 1],
                        [2, 2],
                        [2, 3],
                    ],
                    [
                        [3, 0],
                        [3, 1],
                        [3, 2],
                        [3, 3],
                    ],
                    [
                        [4, 0],
                        [4, 1],
                        [4, 2],
                        [4, 3],
                    ],
                ];
            case 5: //  RIGHT TO LEFT
                return [
                    [
                        [4, 0],
                        [4, 1],
                        [4, 2],
                        [4, 3],
                    ],
                    [
                        [3, 0],
                        [3, 1],
                        [3, 2],
                        [3, 3],
                    ],
                    [
                        [2, 0],
                        [2, 1],
                        [2, 2],
                        [2, 3],
                    ],
                    [
                        [1, 0],
                        [1, 1],
                        [1, 2],
                        [1, 3],
                    ],
                    [
                        [0, 0],
                        [0, 1],
                        [0, 2],
                        [0, 3],
                    ],
                ];
            case 6: //  TOP TO BOTTOM
                return [
                    [
                        [0, 0],
                        [1, 0],
                        [2, 0],
                        [3, 0],
                        [4, 0],
                    ],
                    [
                        [0, 1],
                        [1, 1],
                        [2, 1],
                        [3, 1],
                        [4, 1],
                    ],
                    [
                        [0, 2],
                        [1, 2],
                        [2, 2],
                        [3, 2],
                        [4, 2],
                    ],
                    [
                        [0, 3],
                        [1, 3],
                        [2, 3],
                        [3, 3],
                        [4, 3],
                    ],
                ];
            case 7: // BOTTOM TO TOP
                return [
                    [
                        [0, 3],
                        [1, 3],
                        [2, 3],
                        [3, 3],
                        [4, 3],
                    ],
                    [
                        [0, 2],
                        [1, 2],
                        [2, 2],
                        [3, 2],
                        [4, 2],
                    ],
                    [
                        [0, 1],
                        [1, 1],
                        [2, 1],
                        [3, 1],
                        [4, 1],
                    ],
                    [
                        [0, 0],
                        [1, 0],
                        [2, 0],
                        [3, 0],
                        [4, 0],
                    ],
                ];
            case 8: // FROM CENTER
                return [
                    [
                        [2, 0],
                        [2, 1],
                        [2, 2],
                        [2, 3],
                    ],
                    [
                        [1, 0],
                        [1, 1],
                        [1, 2],
                        [1, 3],
                        [3, 0],
                        [3, 1],
                        [3, 2],
                        [3, 3],
                    ],
                    [
                        [0, 0],
                        [0, 1],
                        [0, 2],
                        [0, 3],
                        [4, 0],
                        [4, 1],
                        [4, 2],
                        [4, 3],
                    ],
                ];
            case 9: // TO CENTER
                return [
                    [
                        [0, 0],
                        [0, 1],
                        [0, 2],
                        [0, 3],
                        [4, 0],
                        [4, 1],
                        [4, 2],
                        [4, 3],
                    ],
                    [
                        [1, 0],
                        [1, 1],
                        [1, 2],
                        [1, 3],
                        [3, 0],
                        [3, 1],
                        [3, 2],
                        [3, 3],
                    ],
                    [
                        [2, 0],
                        [2, 1],
                        [2, 2],
                        [2, 3],
                    ],
                ];
        }
    }
}

export const WinAnimatorExtendedAttributes = {
    ACTIVE_ELEMENTS: "ActiveElements",
    PAYLINES_OFFSETS_LEFT_X: "PaylinesOffsetsLeftX",
    PAYLINES_OFFSETS_LEFT_Y: "PaylinesOffsetsLeftY",
    PAYLINES_OFFSETS_RIGHT_X: "PaylinesOffsetsRightX",
    PAYLINES_OFFSETS_RIGHT_Y: "PaylinesOffsetsRightY",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimatorExtended.ts
 **/